import { fetchApi } from "./base";
import { Notification } from "@/types/notifications";

export function getNotifications() {
  return fetchApi<Notification[]>("/api/notifications", {
    method: "GET",
  });
}

export function updateNotificationPreferences(preferences: {
  deliveryMethod: "in-app" | "email" | "both";
}) {
  return fetchApi("/api/notifications/preferences", {
    method: "PATCH",
    body: preferences,
  });
}

export function getNotificationPreferences() {
  return fetchApi("/api/notifications/preferences", {
    method: "GET",
  });
}

export function markNotificationAsRead(id: string) {
  return fetchApi(`/api/notifications/${id}/read`, {
    method: "PATCH",
  });
}
